<template>
  <div class="inbox-head">

    <div class="media align-items-center pa-3 w-100 primary">
      <div class="media-left mr-4">
        <v-avatar
          color="secondary"
          size="32"
        >
          <v-icon class="primary--text">account_circle</v-icon>
        </v-avatar>
      </div>
      <div class="media-body white--text">
        <h5 class="mb-0">{{ usuario ? nombreCompleto : 'cargando...' }}</h5>
        <span class="fs-12 fw-normal">{{ usuario ? usuario.email : '' }}</span>

      </div>
    </div>

    <vue-perfect-scrollbar
      class="inbox-sidebar-scroll"
      :style="getScrollHeight()"
    >
      <div class="inbox-inner pa-4">
        <div class="mailbox-items-warp">
          <!--span class="fs-12 fw-semi-bold px-3 mb-1 d-block">Texto 1</span-->
          <v-list>
            <template v-for="(seccion,key) in secciones">
              <v-list-tile
                @click="cambiarSeccion(seccion)"
                :key="key"
              >
                <v-list-tile-action>
                  <v-icon>{{ seccion.icono }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <span>{{ seccion.nombre }}</span>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </div>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>

export default {

  computed: {
    usuario () {
      return this.$store.getters['detalleUsuario/usuarioSeleccionado'] || null
    },
    persona () {
      return this.$store.getters['detalleUsuario/personaSeleccionada'] || null
    },
    nombreCompleto () {
      return this.persona ? this.persona.apellido + ', ' + this.persona.nombre : ''
    }
  },
  data () {
    return {
      secciones: [
        {
          icono: 'zmdi zmdi-key',
          nombre: 'Datos de cuenta',
          key: 'usuario'
        },
        {
          icono: 'zmdi zmdi-account-circle',
          nombre: 'Datos personales',
          key: 'persona'
        },
        {
          icono: 'zmdi zmdi-folder-outline',
          nombre: 'Mis archivos',
          key: 'archivo'
        },
        {
          icono: 'zmdi zmdi-file-plus',
          nombre: 'Recetas',
          key: 'receta',
          permiso: 'recetas',
          items: []
        },
        {
          icono: 'zmdi zmdi-hospital-alt',
          nombre: 'Estudios',
          key: 'estudio',
          permiso: 'estudios',
          items: []
        }
      ]

    }
  },
  methods: {
    cambiarSeccion (seccion) {
      this.$emit('cambiarSeccion', seccion.key)
    },
    getScrollHeight () {
      return 'height:calc(100vh - 200px)'
    }
  }

}
</script>
